/**
 * @fileOverview This file contains the permission nodes for the admin access and quera access
 */

export const COURSE_ADMIN_PERMISSION = "qbraid.extensions.coursebuilder";
